import { locale, addMessages, init } from "svelte-i18n";

const deDict = {
  myAccount: "Mein Konto",
  logout: "Ausloggen",
  login: "Login",
  password: "Passwort",
  passwordConfirmation: "Passwort Bestätigung",
  setPassword: "Passwort registrieren",
  minLengthPassword: "Das Passwort sollte mindestens 8 Zeichen lang sein.",
  confirmationNotMatch:
    "Passwort Bestätigungsfeld stimmt nicht mit Passwortfeld überein",
  forgotPassword: "Passwort vergessen",
  passwordRecovery: "Passwort-Wiederherstellung",
  passwordRecoveryDescription:
    "Eine E-Mail wurde an {email} mit einem Link zum Zurücksetzen Ihres Passworts gesendet.",
  passwordRecoveryNoUserDescription:
    "Kein Benutzer mit E-Mail {email} gefunden.",
  resetPassword: "Passwort zurücksetzen",
  register: "Registrieren",
  registerLink:
    "Wenn Sie noch kein Konto haben, folgen Sie bitte diesem Link, um sich zu registrieren",
  moreinfo: "Mehr zur ILK erfahren",
  common: {
    close: "schliessen",
    home: "Startseite",
    events: "Veranstaltungen",
    workhops: "Workshops",
    blog: "Aktuelles",
  },
  blog: {
    more: "Mehr dazu",
    all: "Alle Artikel",
  },
  generalDocuments: "Hintergrunddokumente",
  ilkConference: "Tagung ilk –",
  cosecConference: "Tagung KoRa –",
  presentations: "Referate und präsentationen",
  downloads: {
    program: "Detailliertes Programm herunterladen",
    flyer: "ILK Flyer herunterladen",
    participants: "Teilnehmende",
  },
  account: {
    participatingList: "Registrierte Veranstaltungen",
  },
  event: {
    program: "Programm",
    notRegistered: "Sie haben sich nicht für diese Veranstaltung registriert",
    registered: "Sie haben sich bereits für diese Veranstaltung angemeldet",
    register: "teilnehmen",
    unregister: "nicht teilnehmen",
    registrationConfirmation: "Anmeldebestätigung",
    registrationConfirmationDetail:
      "Sie erhalten in Kürze eine E-Mail mit den Einzelheiten der Registrierung",
    unregistrationConfirmation: "Abmeldebestätigung",
    unregistrationConfirmationDetail:
      "Sie erhalten in Kürze eine E-Mail mit der Abmeldebestätigung.",
    accessForMore: "zur Anmeldung",
  },
  workshop: {
    empty: "Derzeit ist kein Workshop geplant",
  },
  registration: {
    form: "Anmeldung",
    name: "Vorname",
    surname: "Name",
    email: "E-Mail Addresse",
    role: "Funktion",
    party: "Partei",
    canton: "Kanton",
    disclaimer:
      "Ich bin einverstanden, die Teilnahmegebühr von CHF 80.– vor der Veranstaltung zu begleichen. Die Kontoangaben befinden sich in der Bestätigungsnachricht.",
    placeholder: "Bitte auswählen",
    action: "Anmelden",
    success1: "Besten Dank für Ihre Anmeldung.",
    success2: "Sie erhalten in Kürze eine Bestätigung per E-Mail.",
    error1: "Ein unerwarteter Fehler ist aufgetreten.",
    error2: "Bitte versuchen Sie es später nochmals.",
    save: "Speichern",
    password: "Passwort",
    passwordConfirm: "Passwort bestätigen",
    hintPasswordConfirmation:
      "Passwortbestätigung stimmt nicht mit dem Passwort überein",
    hintPassword: "Das Passwort sollte mindestens 8 Zeichen lang sein",
  },
  footer: {
    contact: "Anschrift",
    address1: "Interkantonale Legislativkonferenz",
    address2: "c/o Haus zum Rechberg",
    address3: "Hirschengraben 40",
    address4: "8090 Zürich",
  },
  error: {
    email: "E-Mail Addresse",
    taken: "Diese Email wurde bereits verwendet",
    invalidUserOrPassword: "Ungültiger Benutzer oder Passwort",
  },
  privacyPolicy: {
    title: "Datenschutzerklärung",
    text: "Gestützt auf Artikel 13 der Schweizerischen Bundesverfassung und die datenschutzrechtlichen Bestimmungen des Bundes (Datenschutzgesetz, DSG) hat jede Person Anspruch auf Schutz ihrer Privatsphäre sowie auf Schutz vor Missbrauch ihrer persönlichen Daten. Die ILK hält diese Bestimmungen ein. Persönliche Daten werden vertraulich behandelt und insbesondere nicht an unberechtigte Dritte weitergegeben.",
  },
};

const frDict = {
  myAccount: "Mon compte",
  logout: "Se déconnecter",
  login: "Login",
  password: "Mot de passe",
  passwordConfirmation: "Confirmation mot de passe",
  setPassword: "Enregistrer le mot de passe",
  minLengthPassword: "Le mot de passe doit comporter au moins 8 caractères.",
  confirmationNotMatch:
    "La confirmation du mot de passe ne correspond pas au mot de passe.",
  forgotPassword: "Mot de passe oublié",
  passwordRecovery: "Récupération de mot de passe",
  passwordRecoveryDescription:
    "Un e-mail a été envoyé à test@mail.com avec un lien pour réinitialiser votre mot de passe.",
  passwordRecoveryNoUserDescription:
    "Aucun utilisateur trouvé avec l'email {email}.",
  resetPassword: "Réinitialiser le mot de passe",
  register: "S'inscrire",
  registerLink:
    "Si vous n'avez pas encore de compte, veuillez suivre ce lien pour vous inscrire",
  moreinfo: "En savoir plus sur la CLI",
  common: {
    close: "Fermer",
    home: "Page d'accueil",
    events: "Événements",
    workhops: "Ateliers",
    blog: "Actualités",
  },
  blog: {
    more: "En savoir plus",
    all: "Tous les articles",
  },
  generalDocuments: "Documents de base",
  ilkConference: "Conférence CLI –",
  cosecConference: "Conférence de la Cosec –",
  presentations: "Discours et présentations",
  downloads: {
    program: "Télécharger le programme détaillé",
    flyer: "Télécharger le dépliant de la CLI",
    participants: "Participants",
  },
  account: {
    participatingList: "Événements enregistrés",
  },
  event: {
    program: "Programme",
    notRegistered: "Vous n'êtes pas inscrit à cet événement",
    registered: "Vous êtes déjà inscrit à cet événement",
    register: "participer",
    unregister: "se désinscrire",
    registrationConfirmation: "Confirmation d'enregistrement",
    registrationConfirmationDetail:
      "Vous recevrez bientôt un mail avec le détail de l'inscription",
    unregistrationConfirmation: "Confirmation de désinscription",
    unregistrationConfirmationDetail:
      "Vous recevrez bientôt un mail avec la confirmation de désinscription.",
    accessForMore: "Connectez-vous pour le contenu réservé",
  },
  workshop: {
    empty: "Il n'y a actuellement aucun atelier prévu",
  },
  registration: {
    form: "Inscription",
    name: "Prénom",
    surname: "Nom",
    email: "Adresse e-mail",
    role: "Rôle",
    party: "Parti politique",
    canton: "Canton",
    disclaimer:
      "J'accepte de payer les frais de participation de CHF 80.– en amont de la manifestation. Les détails de payment se trouvent dans le message de confirmation.",
    placeholder: "Veuillez choisir",
    action: "Envoyer",
    success1: "Merci pour votre inscription.",
    success2: "Vous recevrez sous peu un e-mail de confirmation.",
    error1: "Une erreur inattendue s'est produite.",
    error2: "Veuillez réessayer plus tard.",
    save: "Enregistrer",
    password: "Mot de passe",
    passwordConfirm: "Confirmez le mot de passe",
    hintPasswordConfirmation:
      "La confirmation du mot de passe ne correspond pas au mot de passe",
    hintPassword: "Le mot de passe doit contenir au moins 8 caractères",
  },
  footer: {
    contact: "Contact",
    address1: "Conférence législative intercantonale",
    address2: "c/o  Haus zum Rechberg",
    address3: "Hirschengraben 40",
    address4: "8090 Zurich",
  },
  error: {
    email: "Adresse e-mail",
    taken: "Cet e-mail a déjà été utilisé",
    invalidUserOrPassword: "Utilisateur ou mot de passe invalide",
  },
  privacyPolicy: {
    title: "Politique de confidentialité",
    text: "En vertu de l’article 13 de la Constitution fédérale suisse et des dispositions de la Confédération suisse relatives à la protection des données (loi sur la protection des données, LPD), toute personne a droit à la protection de sa vie privée et à la protection contre l’utilisation abusive de ses données personnelles. La CLI se conforme à ces dispositions. Les données personnelles sont traitées de manière confidentielle et ne sont notamment pas transmises à des tiers non autorisés.",
  },
};

addMessages("de", deDict);
addMessages("fr", frDict);

export const languageInit = (hostname) => {
  if (hostname === "parlements.ch" || hostname === "www.parlements.ch") {
    locale.set("fr");
  } else {
    locale.set("de");
  }
  init({
    fallbackLocale: "de",
    initialLocale: "de",
  });
};
